// extracted by mini-css-extract-plugin
module.exports = {"page":"ProfilePage_page__2SAW9 page_page__31uF2"};